import React from 'react';

import { SaveButton } from '../button/save-button/SaveButton';

import './Modal.css';

const Modal = ({
  children,
  closeModal,
  headerTitle,
  buttonTitle,
  width,
  height,
  contentPadding,
  setIsModalOpen,
  hideButton,
  justifyContent,
  red,
}) => {
  const handleSaveClick = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="modal-overlay" style={{ justifyContent: justifyContent }}>
      <div className="modal" style={{ width, height }}>
        <div className={`modal-header ${red ? 'red' : ''}`}>
          <h3 className="modal-title">{headerTitle}</h3>
          {closeModal && (
            <button className="close-button" onClick={closeModal}>
              &times;
            </button>
          )}
        </div>
        <div className={`modal-content-block ${red ? 'red' : ''}`} style={{ padding: contentPadding }}>
          {children}
        </div>
        {!hideButton && (
          <div className="modal-save-button">
            <SaveButton color={'#74a47f'} title={buttonTitle} onClick={handleSaveClick} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
